require("flatpickr/dist/flatpickr.min")
require("flatpickr/dist/themes/light.css");

var default_config = { altFormat: "m/d/Y", altInput: true, allowInput: true, enableTime: false, dateFormat: "Y-m-d",
                       isMobile: true };
$(".default-flatpickr").flatpickr(default_config)
